export default __webpack_public_path__ + "static/media/icon-message-close-sidebar.509c1550.svg";